import React from 'react'
import { Container, Flex, Box, css } from 'theme-ui'
import ContentContainer from '@solid-ui-components/ContentContainer'
import { ImQuotesRight } from 'react-icons/im'
import { AiFillStar } from 'react-icons/ai'
import Reveal from '@solid-ui-components/Reveal'
import Tabs from '@solid-ui-components/Tabs'
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent'
import ContentText from '@solid-ui-components/ContentText'
import {nanoid} from "nanoid"
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
const styles = {
  avatar: {
    borderRadius: "50%",
    width: "100%",
    maxWidth: "250px",
    height: "100%",
    div:{
      maxWidth: "unset !important"
    }
  },
  img: { width: "100%", height: "100%", maxWidth: "auto !important"}
}

const TestimonialsBlock03 = ({
  content: { kicker, title, collection },
  autoplayInterval = 4000,
  reverse
}) => (
  <Container sx={{mb: "4"}}>
    <Box
      sx={{
        textAlign: "center",
        marginBottom: "2rem"
      }}
    >
      <Reveal effect={reverse ? 'fadeInLeft' : 'fadeInRight'} threshold={0.7}>
        <ContentText content={title} variant="h2"/>
        <ContentText content={kicker} variant="h3"/>
      </Reveal>
    </Box>
    <Box>
      <Tabs variant='dots' position='bottom' space={3} autoplay autoplayInterval={autoplayInterval}>
        {collection?.map(
          ({ container, title, description, avatar, text_1, text_2 }, index) => {
            const generalKey = nanoid();
            return (
            <ContentContainer
              content={container}
              variant='cards.paper'
              key={`${generalKey}-contentContainer-${index}`}
              py="5"
              sx={{ position: `relative`, borderRadius: "5px" }}
            >
              <Flex
                key={`${generalKey}-Flex-${index}`}
                sx={{
                  flexDirection: ["column", "column","column", "row"],
                  alignItems: `center`,
                  position: `relative`,
                  flexWrap: `wrap`,
                  zIndex: 1
                  
                }}
              >
                <Box sx={{flex: 1}} key={`${generalKey}-AvatarWrapper-${index}`}>
                  <Reveal effect='fadeInRotate' key={`${generalKey}-Reveal-${index}`}>
                    <GatsbyImage
                      key={`${generalKey}-img-avatar-${index}`}
                      image={getImage({...avatar?.src.ImageSharp, __typename: "ImageSharp"})}
                      alt={avatar?.alt}
                      css={css({...styles.avatar})}
                      imgStyle={styles.img}
                    />
                  </Reveal>
                </Box>
                <Box sx={{ flex: 2, ml: [0, 4], textAlign: "left" }} key={`${generalKey}-ContentWrapper-${index}`}>
                  <Reveal effect='fadeInUp' key={`${generalKey}-FadeInUp-${index}`}>
                    <ContentText content={title} variant='h4' sx={{fontWeight: 700, }} key={`${generalKey}-title-${index}`} />
                    <ContentText content={description} variant='p'  key={`${generalKey}-description-${index}`}/>
                    {Array.from({ length: 5 }, (_, i) => (
                      <Reveal
                        key={`${generalKey}-star-${index}-${i}`}
                        effect='fadeInRotate'
                        delay={0.2 * (i + 1)}
                        css={css({ display: `inline-block` })}
                      >
                        <AiFillStar
                          css={css({ color: `beta`, size: `icon.xs` })}
                        />
                      </Reveal>
                    ))}
                    <ContentText content={text_1} variant='p' sx={{fontWeight: "bold",mb:"0"}} key={`${generalKey}-text1-${index}`}/>
                    <ContentText content={text_2} variant='p' key={`${generalKey}-text2-${index}`}/>
                  </Reveal>
                </Box>
              </Flex>
              <ImQuotesRight
                key={`${generalKey}-Quote-${index}`}
                css={css({
                  size: `30%`,
                  color: `omegaLighter`,
                  position: `absolute`,
                  transform: `translate(0, -20%)`,
                  bottom: 0,
                  right: 0
                })}
              />
            </ContentContainer>
          )}
        )}
      </Tabs>
    </Box>
  </Container>
)

export default WithDefaultContent(TestimonialsBlock03)
